import { render, staticRenderFns } from "./LastPublished.vue?vue&type=template&id=3cac8805&scoped=true&"
import script from "./LastPublished.vue?vue&type=script&lang=js&"
export * from "./LastPublished.vue?vue&type=script&lang=js&"
import style0 from "./LastPublished.vue?vue&type=style&index=0&id=3cac8805&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cac8805",
  null
  
)

export default component.exports